import Moment from "moment";
import { getToken, getUser } from "../../Utils/Common";
import { getAPICall, postAPICall } from "../axiosMethodCalls";

export const getAllGatePass = async (data) => {

    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "gate_passes/get",
            {
                requester: getUser(),
                token: getToken(),
                gate_pass_id: data.id ? data.id : "",
                branch_id: data.branch_id ? data.branch_id : "",
                type: data.type ? data.type : "",
                transfer_no: data.transfer_no ? data.transfer_no : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                page: data.page ? data.page : "",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};


export const getGatePass = async (id, transfer_id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK+"gate_passes/get", 
            {
                requester: getUser(),
                token: getToken(),
                gate_pass_id: id,
                transfer_id: transfer_id
            }
        )
        return {data: response.data}
    } catch (error) {
        return {error: error.response}
    }
}

export const createGatePass = async (transfer_ids, data, items) => {
    let formData = new FormData();
    formData.append('requester', getUser());
    formData.append('token', getToken());
    // formData.append('transfer_id', transfer_id);
    formData.append('gate_pass_date', data.gate_pass_date ? data.gate_pass_date : "");
    formData.append('transfer_time', data.transfer_time ? data.transfer_time : "");
    formData.append('branch_id', data.branch_id ? data.branch_id : "");
    formData.append('plate_no', data.plate_no ? data.plate_no : "");
    formData.append('status', data.status ? data.status : "");
    formData.append('type', data.type ? data.type : "");
    formData.append('change_status_by', data.change_status_by ? data.change_status_by : "");
    formData.append('change_status_on', data.change_status_on ? data.change_status_on : "");
    formData.append('customer', data.customer ? data.customer : "");
    formData.append('charge_invoice', data.charge_invoice ? data.charge_invoice : "");
    formData.append('dr_no', data.dr_no ? data.dr_no : "");
    formData.append('driver', data.driver ? data.driver : "");
    formData.append('delivery_personnel', data.delivery_personnel ? data.delivery_personnel : "");

    transfer_ids.map((id) => {
        formData.append(`transfer_ids[]`, id);
    })
    items.map((item) => {
        formData.append(`description[]`,item.description ? item.description : "");
        formData.append(`unit[]`,item.unit ? item.unit : "");
        formData.append(`qty[]`,item.qty ? item.qty : "");
        formData.append(`consignment_no[]`,item.consignment_no ? item.consignment_no : "");
    })

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "gate_passes/create", formData
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updateGatePass = async (data, items) => {
        const formData = new FormData(); 
    formData.append('requester', getUser());
    formData.append('token', getToken());
    formData.append('gate_pass_id', data.id);
    // formData.append('transfer_id', data.transfer_id);
    formData.append('gate_pass_date', data.gate_pass_date ? data.gate_pass_date : "");
    formData.append('transfer_time', data.transfer_time ? data.transfer_time : "");
    formData.append('branch_id', data.branch_id ? data.branch_id : "");
    formData.append('plate_no', data.plate_no ? data.plate_no : "");
    formData.append('status', data.status ? data.status : "");
    formData.append('type', data.type ? data.type : "");
    formData.append('change_status_by', data.change_status_by ? data.change_status_by : "");
    formData.append('change_status_on', data.change_status_on ? data.change_status_on : "");
    formData.append('customer', data.customer ? data.customer : "");
    formData.append('charge_invoice', data.charge_invoice ? data.charge_invoice : "");
    formData.append('dr_no', data.dr_no ? data.dr_no : "");
    formData.append('driver', data.driver ? data.driver : "");
    formData.append('delivery_personnel', data.delivery_personnel ? data.delivery_personnel : "");

    data.transfers.map((transfer) => {
        formData.append(`transfer_ids[]`, transfer.id);
    })
    items.map((item) => {
        formData.append(`gate_pass_item_id[]`,item.id);
        formData.append(`description[]`,item.description ? item.description : "");
        formData.append(`unit[]`,item.unit ? item.unit : "");
        formData.append(`qty[]`,item.qty ? item.qty : "");
        formData.append(`consignment_no[]`,item.consignment_no ? item.consignment_no : "");
    })

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "gate_passes/update", formData
        );
        return {data: response.data};
    } catch (error) {
        return { error: error.response };
    }
};

export const deleteGatePass = async (id) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK+"/gate_passes/delete",
             {requester: getUser(), token: getToken(), gate_pass_id: id}
        );
        return {data: response.data}
    } catch (error) {
        return {error: error.response}
    }
}

export const changeGatePassStatus = async (id, status) => {

    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "gate_passes/change_status",
            {
                requester: getUser(),
                token: getToken(),
                gate_pass_id: id ? id : "",
                status: status ? status : "",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};
